import { render } from "./UserWatch.vue?vue&type=template&id=5844372e"
import script from "./UserWatch.vue?vue&type=script&lang=js"
export * from "./UserWatch.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3829526335/src/github.com/DeepAngle/DDR-Atlas-Proto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__